import { render, staticRenderFns } from "./EditBaseData.vue?vue&type=template&id=18be9f6c&"
import script from "./EditBaseData.vue?vue&type=script&lang=js&"
export * from "./EditBaseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports